import { useQuery } from '@tanstack/react-query';
import { STAGES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { useMemo } from 'react';

export const useQueryStages = (constructionSiteId: number) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [STAGES_QUERY_KEY, constructionSiteId],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const response = await ObrasApiV2.listStages(constructionSiteId);
      return response.data.data;
    },
    enabled: !!constructionSiteId,
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
